import * as React from 'react';
import { Section } from 'src/store/sections/types';
import { ApplicationState } from 'src/store';
import SectionItem from './Section';
import { connect } from 'react-redux';
import { getSections } from 'src/store/sections/actions';

import './Section.scss';
import LoadingSpinner from '../utils/LoadingSpinner/LoadinSpinner';
import { NormalizedObjectsString } from 'src/store/shared/types';

interface PropsFromState {
  loading: boolean;
  sections: NormalizedObjectsString<Section>;
  error?: Error;
}

interface PropsFromDispatch {
  getSections: typeof getSections;
}

interface Props {
  linkBase: string;
}

type AllProps = PropsFromDispatch & PropsFromState & Props;

class SectionList extends React.Component<AllProps> {
  public componentDidMount() {
    this.props.getSections();
  }

  public render() {
    const { loading, sections, linkBase } = this.props;

    return (
      <div className="sectionlist">
        <LoadingSpinner pending={loading} />
        {sections.allIds.map((title: string, index: number) => {
          const section: Section = sections.byId[title];
          return (
            <SectionItem
              link={`${linkBase}/${encodeURI(section.title).toLowerCase()}`}
              section={section}
              key={index}
              style={this.calculateDelay(index)}
            />
          );
        })}
      </div>
    );
  }

  private calculateDelay = (index: number): React.CSSProperties => {
    const delay = index * 0.1;
    return {
      animationDelay: delay + 's'
    };
  };
}

const mapStateToProps = ({ sections }: ApplicationState) => ({
  loading: sections.loading,
  sections: sections.data,
  error: sections.errors
});

const mapDispatchToProps = (dispatch: any) => ({
  getSections: () => dispatch(getSections())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SectionList);



// WEBPACK FOOTER //
// ./src/components/Section/SectionList.tsx